import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces/interfaces';

export interface LoaderReducer {
  fpLoader: boolean;
  menuCollapse: boolean;
}

const initialState: LoaderReducer = {
  fpLoader: false,
  menuCollapse: false,
};

const loaderReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.LOADER.FP_STATUS:
      return {
        ...state,
        fpLoader: action.payload,
      };
    case ACTIONS.LOADER.MENU_COLLAPSE:
      return {
        ...state,
        menuCollapse: action.payload,
      };
    default:
      return state;
  }
};

export default loaderReducer;
